/** Tên loại vật phẩm theo hằng số PetRealmManager (PET_EQUIP_*, ITEM_*). */
export const ITEM_TYPES = {
  "-2": "Vật phẩm xoá",
  "-1": "Vật phẩm admin",
  1: "Vũ khí",
  2: "Giáp",
  3: "Nón",
  104: "Giày",
  105: "Găng tay",
  4: "Cải trang",
  5: "Cánh",
  6: "Bùa cường hoá",
  7: "Bùa cường hoá thiên đình",
  8: "Đá cường hoá",
  9: "Mảnh pet",
  10: "Bình exp",
  11: "Nâng kỹ năng pet",
  12: "Đồ PK",
  13: "Mực xăm",
  14: "Mực tẩy xăm",
  15: "Hỗ trợ pet khi đánh",
  16: "Tiền tệ",
  17: "Ngọc khảm",
  18: "Nguyên liệu cường hoá ngọc",
  19: "Mảnh vật phẩm",
  20: "Bình năng lượng",
  21: "Nguyên liệu cường hoá cánh",
  22: "Hộp quà / gói pet",
  23: "Mực cường hoá xăm",
  24: "Vật phẩm sự kiện",
  25: "Vé luyện tập",
  26: "Danh hiệu (bán trong shop)",
  27: "Thẻ kỹ năng",
  28: "Thẻ trùng sinh",
  29: "Hộp ngọc ngẫu nhiên",
  30: "Nguyên liệu dung hợp",
  31: "Bụi ngọc",
};

export const itemTypeLabel = (type) => ITEM_TYPES[type] || `Loại ${type}`;

export const ELEMENTS = {
  1: "Lửa",
  2: "Mộc",
  3: "Đá",
  4: "Sét",
  5: "Nước",
  6: "Bóng tối",
  7: "Ánh sáng",
};

export const NCLASSES = {
  0: "Chiến binh",
  1: "Sát thủ",
  2: "Pháp sư",
  3: "Thiên sứ",
  4: "Thiên binh",
  5: "Thiên ma",
};

export const elementLabel = (value) => ELEMENTS[value] || "-";
export const nclassLabel = (value) => NCLASSES[value] || "-";

/** "80 - 85" cho khoảng chỉ số [min, max]. */
export function rangeText(range) {
  if (!range || range.length === 0) return "";
  return range.length === 1 || range[0] === range[1] ? `${range[0]}` : `${range[0]} - ${range[1]}`;
}

/** Loại vật phẩm mà itemOption[i] là mã dòng của itemOptionValue[i] (khớp PAIRED_OPTION_TYPES ở server). */
export const PAIRED_OPTION_TYPES = [4, 5, 8, 10, 11, 15, 17, 25];
export const GEM_TYPE = 17;
export const WING_TYPES = [4, 5];

/** Mã dòng option (ItemInfo.OptionType và các mã riêng của từng loại vật phẩm). */
export const OPTION_CODES = {
  1: "Toạ độ vẽ X (chỉ hình ảnh)",
  2: "Toạ độ vẽ Y (chỉ hình ảnh)",
  3: "% cộng tỉ lệ cường hoá",
  5: "% exp cộng thêm",
  6: "% cộng tỉ lệ nâng kỹ năng",
  7: "Hồi HP",
  8: "Hồi MP",
  9: "% HP (× 100)",
  10: "% MP (× 100)",
  11: "% ATK (× 100)",
  12: "% DEF (× 100)",
  13: "Hiệu ứng trong trận",
  14: "Số lượt (> 100 = cả trận)",
  15: "Giá trị (% × 100, âm = giảm)",
  16: "Cho ai (1 = mình, 0 = đối thủ)",
  17: "Số giờ tăng rơi tiền",
  18: "Chống PK",
  19: "HP phẳng",
  20: "MP phẳng",
  21: "ATK phẳng",
  22: "DEF phẳng",
};

export const GEM_OPTION_CODES = [21, 22, 19, 20];
export const GEM_LEGACY_OPTION_CODES = [11, 12, 9, 10];
export const SKIN_PERCENT_CODES = [11, 12, 9, 10];

export const optionCodeLabel = (code) => OPTION_CODES[code] || `Mã ${code}`;

/** Mã hiệu ứng nạp vào trận (giá trị của dòng 13, ItemInfo.Type). */
export const BATTLE_LINES = {
  15: "Tăng / giảm sát thương",
  10: "Tăng / giảm giáp",
  24: "Hút máu theo sát thương",
  32: "Phản đòn",
  36: "Tỉ lệ choáng 1 lượt",
  25: "Né đòn",
  51: "Tỉ lệ chí mạng",
  52: "Sát thương chí mạng",
  53: "Vết thương sâu (giảm hồi HP đối thủ)",
  54: "Kháng vết thương sâu",
  56: "Tỉ lệ cấm ngôn",
  57: "Kháng cấm ngôn",
  58: "Bỏ qua kháng",
  62: "Giảm sát thương nhận",
  63: "Hồi % HP mỗi lượt",
};

/** Hiệu ứng mà mô tả cánh trong game hiện ra (Item.getDescription); mã khác vẫn có tác dụng nhưng không hiện chữ. */
export const DESCRIBED_BATTLE_LINES = [15, 10, 32, 36, 24];

export const battleLineLabel = (id) => BATTLE_LINES[id] || `Mã hiệu ứng ${id}`;

/** Ý nghĩa danh sách giá trị với loại vật phẩm không dùng dạng cặp. */
export const OPTION_VALUE_HINTS = {
  9: "[id pet nhận được, số mảnh cần]",
  13: "Danh sách id hình xăm có thể ra (xem tab Hình xăm)",
  18: "[% cộng tỉ lệ cường hoá ngọc]",
  19: "[id vật phẩm nhận được, số mảnh cần]",
  22: "Danh sách id vật phẩm / pet trong gói",
  26: "[id danh hiệu, ...]",
  27: "Danh sách id kỹ năng có thể học",
  29: "Danh sách id ngọc có thể nhận",
  32: "Danh sách id kỹ năng bị động có thể học",
};

const signed = (v) => (v > 0 ? `+${v}` : `${v}`);

/** Tóm tắt option cho cột "Chỉ số" của bảng vật phẩm. */
export function optionSummary(item) {
  const options = item.itemOption || [];
  const values = item.itemOptionValue || [];
  if (!options.length && !values.length) return [];
  if (item.type === GEM_TYPE) {
    return [
      options
        .map((code, i) => `${optionCodeLabel(code).replace(" phẳng", "")} +${values[i] ?? 0}`)
        .join(" · "),
    ];
  }
  if (WING_TYPES.includes(item.type)) {
    const lines = [];
    for (let i = 0; i < options.length; i += 1) {
      if (options[i] === 13 && i + 3 < values.length) {
        const turns = values[i + 1] > 100 ? "cả trận" : `${values[i + 1]} lượt`;
        const target = values[i + 3] === 1 ? "lên mình" : "lên đối thủ";
        lines.push(
          `${battleLineLabel(values[i])} ${signed(values[i + 2] / 100)}%, ${turns}, ${target}`
        );
        i += 3;
      } else if (SKIN_PERCENT_CODES.includes(options[i])) {
        const label = optionCodeLabel(options[i]).replace(" (× 100)", "");
        lines.push(`${label} ${signed(values[i] / 100)}%`);
      } else if (options[i] === 18) {
        lines.push("Chống PK");
      }
    }
    return lines;
  }
  if (PAIRED_OPTION_TYPES.includes(item.type)) {
    return [options.map((code, i) => `${optionCodeLabel(code)}: ${values[i] ?? "-"}`).join(" · ")];
  }
  return values.length ? [`Giá trị: ${values.join(", ")}`] : [];
}
